import { BaseRequest, IBaseRequest } from "../../BaseRequest";

export interface IMoveMessageRequest extends IBaseRequest {
  MESSAGE: MoveMessagePayload;
}

export interface MoveMessagePayload {
  id: string;
  messageId: string;
  newNode: string;
  doNotMoveThread?: string;
}

export class MoveMessageRequest
  extends BaseRequest
  implements IMoveMessageRequest
{
  public MESSAGE: MoveMessagePayload;

  constructor(server: string, session: string, message: MoveMessagePayload) {
    super(server, session);
    this.MESSAGE = message;
  }

  public toXml(): string {
    let parameters = super.toXml();
    parameters += `<MESSAGE>`;
    parameters += this.makeNode(this.MESSAGE.id, "id");
    parameters += this.makeNode(this.MESSAGE.messageId, "messageId");
    parameters += this.makeNode(this.MESSAGE.newNode, "newNode");
    parameters += this.makeNode(
      this.MESSAGE.doNotMoveThread ?? "1",
      "doNotMoveThread",
    );
    parameters += `</MESSAGE>`;

    return super.wrapperXml("MoveMessage", parameters);
  }
}
